export const postOvernightCampParticipantsAndEnrollmentSelector = ({
  yusaOvernightCampParticipantsAndEnrollmentData: {
    postOvernightCampEnrollment
  }
}) => postOvernightCampEnrollment;

export const getOvernightCampParticipantsAndEnrollmentListSelector = ({
  yusaOvernightCampParticipantsAndEnrollmentData: { getOvernightCampEnrollment }
}) => getOvernightCampEnrollment;

export const GetParticipantsDataSelector = ({
  yusaOvernightCampParticipantsAndEnrollmentData: {
    getOvernightCampParticipantsList
  }
}) => getOvernightCampParticipantsList;

export const PostParticipantsDataSelector = ({
  yusaOvernightCampParticipantsAndEnrollmentData: {
    postOvernightCampParticipantsList
  }
}) => postOvernightCampParticipantsList;
